import {  Component, OnInit } from '@angular/core';
import { BaseComponent } from './@base/base.component';
import { firstValueFrom, } from 'rxjs';
import { LOCAL_STORAGE_KEY_BANNERS } from './const/localStorageKeys';
import { NavigationEnd } from '@angular/router';
import { BannerService } from './services/banner.service';
import { Meta } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-root',
  template: `
    <router-outlet></router-outlet>
    <app-cookie-consent></app-cookie-consent>
    <app-install-pwa></app-install-pwa>
  `
})
export class AppComponent extends BaseComponent implements OnInit {
  public whatsapp: HTMLElement;
  public webchat: HTMLElement;

  constructor(
    private bannerService: BannerService,
    private readonly _meta: Meta
  ){
    super()


    this.router.events.subscribe((event: NavigationEnd) => {

      if (!(event instanceof NavigationEnd)) return;
    });
  }

  ngOnInit(): void {
    this.setApiAndStyleCsp();

    firstValueFrom(this.bannerService.getBanners())
      .then(resp => {
        if(resp){
          this.setLocalStorageItem(LOCAL_STORAGE_KEY_BANNERS, JSON.stringify(resp))

        }
        this.bannerService.bannersSubscribe$.next(null)
      })
  }

  private setApiAndStyleCsp() {
    const cspContent = `
                default-src 'self'  https://fonts.googleapis.com https://cdnjs.cloudflare.com https://fonts.gstatic.com;
                script-src 'self' https://js.monitor.azure.com https://dc.services.visualstudio.com https://www.google.com https://www.gstatic.com;
                style-src 'self' 'unsafe-inline'  https://cdnjs.cloudflare.com ;
                img-src 'self' data: blob: https://${environment.BLOB_INTERNAL_DOMAIN};
                font-src 'self' https://fonts.gstatic.com https://cdnjs.cloudflare.com;
                connect-src 'self' ${environment.API.replace('/api/v1/', '')} https://js.monitor.azure.com https://dc.services.visualstudio.com https://www.google.com;
                media-src 'self' https://${environment.BLOB_INTERNAL_DOMAIN};
                frame-src 'self' https://www.google.com https://www.youtube.com https://www.youtube-nocookie.com;
    `;

    this._meta.addTag({ httpEquiv: 'Content-Security-Policy', content: cspContent});
  }



}
